export const FACILIOO_UNIT_TYPE_VALUES = [
  "wohnung",
  "sonstiges",
  "gewerbeeinheit",
  "aufzug",
  "stellplatz",
  "fond",
  "allgemeines"
] as const;

export type FaciliooUnitType = (typeof FACILIOO_UNIT_TYPE_VALUES)[number];

const LABELS: Record<string, string> = {
  wohnung: "Wohnung",
  sonstiges: "Sonstiges",
  gewerbeeinheit: "Gewerbeeinheit",
  aufzug: "Aufzug",
  stellplatz: "Stellplatz",
  fond: "Fond",
  allgemeines: "Allgemeines"
};

export const formatUnitTypeLabel = (raw?: string) => {
  const key = String(raw ?? "").trim().toLowerCase();
  if (!key) return "-";
  return LABELS[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
};
